/**
 * Single source of truth for the details that appear in both legal documents.
 *
 * REVIEW BEFORE LAUNCH: the entries marked TODO are placeholders that a human
 * must confirm. The documents render whatever is set here, so a stale value
 * ships straight to a public page that regulators and app reviewers read.
 */
export const LEGAL_CONFIG = {
    // Bump both dates when the substance of either document changes, and bump
    // TERMS_VERSION below so existing users are re-prompted to accept.
    effectiveDate: 'August 1, 2026',
    lastUpdated: 'August 1, 2026',

    entity: 'Para Labs LLC',
    product: 'Vixo',
    domain: 'usevixo.com',
    siteUrl: 'https://usevixo.com',

    // TODO(legal): confirm the state of formation and the governing-law venue.
    governingLawState: 'Delaware',

    // TODO(legal): these mailboxes must exist and be monitored before the
    // documents go live. Google's OAuth review contacts the privacy address.
    supportEmail: 'support@usevixo.com',
    privacyEmail: 'privacy@usevixo.com',

    // TODO(legal): a mailing address is required for CCPA/GDPR-style notices
    // and by several app-store review checklists. Fill in before publishing.
    mailingAddress: null
};

/**
 * Acceptance version recorded on the user document as `TermsVersion`.
 * Keep in sync with UserProfile's default. Raising this is what makes the
 * onboarding gate re-prompt users to accept a materially changed agreement.
 */
export const TERMS_VERSION = '1.0';

export const LEGAL_PATHS = {
    terms: '/terms',
    privacy: '/privacy'
};
